<template>
  <!-- 我们服务的客户 -->
  <div class="customer">
    <div class="header">
      <div class="title">我们服务的客户</div>
      <div class="border"></div>
    </div>
    <div class="list">
      <div class="item" v-for="item in customerList" :key="item.id">
        <img :src="item.logo" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import customerLogo1 from "../../../assets/home/customerLogo1.png";
import customerLogo2 from "../../../assets/home/customerLogo2.png";
import customerLogo3 from "../../../assets/home/customerLogo3.png";
import customerLogo4 from "../../../assets/home/customerLogo4.png";
import customerLogo5 from "../../../assets/home/customerLogo5.png";
import customerLogo6 from "../../../assets/home/customerLogo6.png";
import customerLogo7 from "../../../assets/home/customerLogo7.png";
import customerLogo8 from "../../../assets/home/customerLogo8.png";
import customerLogo9 from "../../../assets/home/customerLogo9.png";
import customerLogo10 from "../../../assets/home/customerLogo10.png";
import customerLogo11 from "../../../assets/home/customerLogo11.png";
import customerLogo12 from "../../../assets/home/customerLogo12.png";
import customerLogo13 from "../../../assets/home/customerLogo13.png";
import customerLogo14 from "../../../assets/home/customerLogo14.png";
import customerLogo15 from "../../../assets/home/customerLogo15.png";

export default {
  setup() {
    return reactive({
      customerList: [
        {
          id: 1,
          logo: customerLogo1,
        },
        {
          id: 2,
          logo: customerLogo2,
        },
        {
          id: 3,
          logo: customerLogo3,
        },
        {
          id: 4,
          logo: customerLogo4,
        },
        {
          id: 5,
          logo: customerLogo5,
        },
        {
          id: 6,
          logo: customerLogo6,
        },
        {
          id: 7,
          logo: customerLogo7,
        },
        {
          id: 8,
          logo: customerLogo8,
        },
        {
          id: 9,
          logo: customerLogo9,
        },
        {
          id: 10,
          logo: customerLogo10,
        },
        {
          id: 11,
          logo: customerLogo11,
        },
        {
          id: 12,
          logo: customerLogo12,
        },
        {
          id: 13,
          logo: customerLogo13,
        },
        {
          id: 14,
          logo: customerLogo14,
        },
        {
          id: 15,
          logo: customerLogo15,
        },
      ],
    });
  },
};
</script>

<style scoped>
.customer {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 5px auto 0;
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 16px;
}
.list .item {
  margin-bottom: 6px;
}
.list .item img {
  width: 64px;
}
</style>
